/**
 * The wall display's one request.
 *
 * **One, because nobody is standing at the screen.** The wall is a tablet on a shelf that
 * reloads itself; five round trips on a kitchen's wifi would leave three columns from one
 * minute and two from another, and nobody is there to press refresh.
 *
 * Read-only. Ticking a chore on the wall goes to `api/chores.js`, so a tick is recorded in
 * exactly one place however it was made.
 */

import { api } from './client.js';

export async function wall() {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  return api.get(`/people/wall/?tz=${encodeURIComponent(tz)}`);
}
